import { render, staticRenderFns } from "./ProjectSelect.vue?vue&type=template&id=ce2880ae&scoped=true&"
import script from "./ProjectSelect.vue?vue&type=script&lang=ts&"
export * from "./ProjectSelect.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectSelect.vue?vue&type=style&index=0&id=ce2880ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2880ae",
  null
  
)

export default component.exports